export default __webpack_public_path__ + "static/media/HallmarkChannelLogo.8a5e9e53.svg";